import React, { Component } from "react";
import Ink from "react-ink";
import LightSpeed from "react-reveal/LightSpeed";
//import { WEBSITE_URL } from "../../../configs/website";
import WebShare from "../WebShare";
import { withRouter } from "react-router-dom";

class BackWithSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showHeader: !props.showOnlyOnScroll,
      lastScrollY: 0,
    };
  }

  componentDidMount() {
    if (this.props.showOnlyOnScroll || this.props.hideOnScrollDown) {
      this.attachScroll();
      this.handleScroll();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.showOnlyOnScroll !== this.props.showOnlyOnScroll ||
      prevProps.hideOnScrollDown !== this.props.hideOnScrollDown ||
      prevProps.scrollTarget !== this.props.scrollTarget) {
      if (this.props.showOnlyOnScroll || this.props.hideOnScrollDown) {
        this.detachScroll(); // Detach old
        this.attachScroll(); // Attach new
        if (this.props.hideOnScrollDown) {
          this.setState({ showHeader: true }, this.handleScroll);
        } else {
          this.setState({ showHeader: false }, this.handleScroll);
        }
      } else {
        this.detachScroll();
        this.setState({ showHeader: true });
      }
    }
  }

  componentWillUnmount() {
    this.detachScroll();
  }

  attachScroll() {
    const target = this.props.scrollTarget || (typeof window !== "undefined" ? window : null);
    if (target) {
      target.addEventListener("scroll", this.handleScroll, { passive: true });
    }
  }

  detachScroll() {
    const target = this.props.scrollTarget || (typeof window !== "undefined" ? window : null);
    if (target) {
      target.removeEventListener("scroll", this.handleScroll);
    }
  }

  handleScroll = () => {
    let scrollTop = 0;
    if (this.props.scrollTarget) {
      scrollTop = this.props.scrollTarget.scrollTop;
    } else if (typeof window !== "undefined") {
      scrollTop =
        window.pageYOffset ||
        (document.documentElement && document.documentElement.scrollTop) ||
        (document.body && document.body.scrollTop) ||
        0;
    }

    // hideOnScrollDown mode: hide when scrolling down, show when scrolling up or at top
    if (this.props.hideOnScrollDown) {
      const { lastScrollY } = this.state;
      const threshold = this.props.scrollThreshold || 50;

      // Always show at top of page
      if (scrollTop < threshold) {
        if (!this.state.showHeader) {
          this.setState({ showHeader: true, lastScrollY: scrollTop });
        } else {
          this.setState({ lastScrollY: scrollTop });
        }
        return;
      }

      // Scrolling down - hide header
      if (scrollTop > lastScrollY && this.state.showHeader) {
        this.setState({ showHeader: false, lastScrollY: scrollTop });
      }
      // Scrolling up - show header
      else if (scrollTop < lastScrollY && !this.state.showHeader) {
        this.setState({ showHeader: true, lastScrollY: scrollTop });
      }
      // Update lastScrollY even when direction hasn't changed enough
      else {
        this.setState({ lastScrollY: scrollTop });
      }
      return;
    }

    // Original showOnlyOnScroll mode
    const threshold = this.props.scrollThreshold || 10; // quick reveal
    const shouldShow = scrollTop > threshold;
    if (shouldShow !== this.state.showHeader) {
      this.setState({ showHeader: shouldShow });
    }
  };

  // Prefer robust back navigation with a reliable fallback.
  // Falls back to a safe route when history can't go back.
  handleSafeBack = () => {
    try {
      const fallbackPath = this.props.fallbackPath || "/";
      const hasWindowHistory = typeof window !== "undefined" && window.history && window.history.length > 1;

      // If React Router history exists, try to go back when feasible
      if (this.props.history) {
        const rrHistory = this.props.history;
        if (hasWindowHistory) {
          rrHistory.goBack();
          return;
        }
        rrHistory.push(fallbackPath);
        return;
      }

      // Fallback to browser history if available
      if (hasWindowHistory) {
        window.history.back();
        return;
      }

      // Absolute last resort
      window.location.assign(fallbackPath);
    } catch (e) {
      // Final safety net
      try {
        const fallbackPath = this.props.fallbackPath || "/";
        if (this.props.history) {
          this.props.history.push(fallbackPath);
        } else {
          window.location.assign(fallbackPath);
        }
      } catch (_) {
        // noop
      }
    }
  };

  render() {
    const title = this.props.isSingleItemDescription
      ? this.props.single_item.brand
        ? this.props.single_item.brand + " - " + this.props.single_item.name
        : this.props.single_item.name
      : this.props.restaurant.name;
    const id = this.props.isSingleItemDescription
      ? this.props.single_item.id
      : "";

    let url = this.props.restaurant.slug;
    if (id) {
      url = url + "/" + id;
    }

    const baseWrapperStyle = { zIndex: "999" };
    let wrapperStyle = baseWrapperStyle;

    if (this.props.showOnlyOnScroll) {
      wrapperStyle = { ...baseWrapperStyle, display: this.state.showHeader ? "block" : "none" };
    } else if (this.props.hideOnScrollDown) {
      wrapperStyle = {
        ...baseWrapperStyle,
        transform: this.state.showHeader ? "translateY(0)" : "translateY(-100%)",
        transition: "transform 0.3s ease-in-out",
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
      };
    }

    return (
      <React.Fragment>
        <div
          className="col-12 p-0 fixed back-with-search-wrapper"
          style={wrapperStyle}
        >
          <div className="block m-0">
            <div
              className={`block-content p-0 back-with-search-header ${this.props.dark && "nav-dark"
                }`}
            >
              <div
                className={`input-group ${this.props.boxshadow &&
                  "search-box"}`}
              >
                {!this.props.disable_back_button && (
                  <div className="input-group-prepend">
                    {this.props.back_to_home && (
                      <button
                        type="button"
                        className="btn search-navs-btns"
                        style={{ position: "relative", border: "none" }}
                        onClick={() => {
                          setTimeout(() => {
                            this.props.history.push("/relax");
                          }, 200);
                        }}
                      >
                        <i className="si si-arrow-left" />
                        <Ink duration="500" />
                      </button>
                    )}

                    {this.props.goto_orders_page && (
                      <button
                        type="button"
                        className="btn search-navs-btns"
                        style={{ position: "relative", border: "none" }}
                        onClick={() => {
                          setTimeout(() => {
                            this.props.history.push("/my-orders");
                          }, 200);
                        }}
                      >
                        <i className="si si-arrow-left" />
                        <Ink duration="500" />
                      </button>
                    )}
                    {this.props.goto_accounts_page && (
                      <button
                        type="button"
                        className="btn search-navs-btns"
                        style={{ position: "relative", border: "none" }}
                        onClick={() => {
                          setTimeout(() => {
                            this.props.history.push("/my-account");
                          }, 200);
                        }}
                      >
                        <i className="si si-arrow-left" />
                        <Ink duration="500" />
                      </button>
                    )}
                    {!this.props.back_to_home &&
                      !this.props.goto_orders_page &&
                      !this.props.goto_accounts_page && (
                        <button
                          type="button"
                          className={`btn search-navs-btns ${this.props.dark &&
                            "nav-dark"}`}
                          style={{ position: "relative", border: "none" }}
                          onClick={() => {
                            // Small delay to allow ripple effect without breaking navigation
                            setTimeout(() => {
                              this.handleSafeBack();
                            }, 120);
                          }}
                        >
                          <i className="si si-arrow-left" />
                          <Ink duration="500" />
                        </button>
                      )}
                  </div>
                )}
                <p
                  className={`form-control search-input d-flex align-items-center ${this
                    .props.dark && "nav-dark"}`}
                  style={{ border: "none", paddingLeft: "0" }}
                >
                  {this.props.logo && (
                    <img
                      src="/assets/img/logos/logo.png"
                      alt={localStorage.getItem("storeName")}
                      width="120"
                    />
                  )}
                  {this.props.has_title ? (
                    <React.Fragment>
                      {this.props.from_checkout ? (
                        <span className="nav-page-title">
                          {localStorage.getItem("cartToPayText")}{" "}
                          <span
                            style={{
                              color: localStorage.getItem("storeColor"),
                            }}
                          >
                            {localStorage.getItem("currencySymbolAlign") ===
                              "left" && localStorage.getItem("currencyFormat")}
                            {this.props.title}
                            {localStorage.getItem("currencySymbolAlign") ===
                              "right" && localStorage.getItem("currencyFormat")}
                          </span>
                        </span>
                      ) : (
                        <span className="nav-page-title">
                          {this.props.title}
                        </span>
                      )}
                    </React.Fragment>
                  ) : null}
                  {this.props.has_delivery_icon && (
                    <LightSpeed left>
                      <img
                        src="/assets/img/various/delivery-bike.png"
                        alt={this.props.title}
                        className="nav-page-title"
                      />
                    </LightSpeed>
                  )}
                </p>
                <div
                  className={`fixed-restaurant-info hidden`}
                  ref={(node) => {
                    this.heading = node;
                  }}
                >
                  <span className="font-w700 fixedRestaurantName">
                    {this.props.isSingleItemDescription
                      ? this.props.single_item.name
                      : this.props.restaurant.name
                        ? this.props.restaurant.name
                        : null}
                  </span>
                </div>
                <div className="input-group-append">
                  {!this.props.disable_search && (
                    <button
                      type="submit"
                      className="btn search-navs-btns"
                      style={{
                        position: "relative",
                        maxWidth: "40px",
                        padding: "4px",
                      }}
                    >
                      <i className="si si-magnifier" />
                      <Ink duration="500" />
                    </button>
                  )}
                  {this.props.homeButton && (
                    <button
                      type="button"
                      className="btn search-navs-btns nav-home-btn"
                      style={{
                        position: "relative",
                        maxWidth: "40px",
                        padding: "4px",
                        height: "50px",
                        marginTop: "2px",
                        border: "none",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      onClick={() => {
                        setTimeout(() => {
                          this.props.history.push(this.props.homePath || "/relax");
                        }, 200);
                      }}
                    >
                      {/* <i className="si si-home" /> */}
                      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-home"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M5 12l-2 0l9 -9l9 9l-2 0" /><path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7" /><path d="M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v6" /></svg>
                      <Ink duration="500" />
                    </button>
                  )}
                  {/* Favourite: render injected AddToFavorite component if provided, else link to favorites page */}
                  {this.props.heartComponent ? (
                    <div style={{
                      display: "flex", alignItems: "center", justifyContent: "center",
                      width: "40px", height: "50px", marginTop: "2px",
                    }}>
                      {this.props.heartComponent}
                    </div>
                  ) : (
                    <button
                      type="button"
                      className="btn search-navs-btns nav-home-btn"
                      style={{
                        position: "relative",
                        maxWidth: "40px",
                        padding: "4px",
                        height: "50px",
                        marginTop: "2px",
                        border: "none",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      onClick={() => {
                        setTimeout(() => {
                          this.props.history.push("/my-wishlist?tab=stores");
                        }, 200);
                      }}
                    >
                      <svg width="22" height="22" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" version="1.1" fill="none" stroke="#000000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="m3.25 9.75c3 3.5 4.75 4.5 4.75 4.5s1.75-1 4.75-4.5 1-7-1.5-7-3.25 3-3.25 3-.75-3-3.25-3-4.5 3.5-1.5 7z"></path> </g></svg>
                      <Ink duration="500" />
                    </button>
                  )}
                  {this.props.shareButton && (
                    <WebShare link={url} title={title} />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(BackWithSearch);
